import React, { PureComponent } from 'react';

import { connect } from 'react-redux';
import { 
	getArticleDetail,
	articleDetail,
	editLikeArticle,
	articleMessageList,
	getArticleMessageList,
	writeArticleMessage,
	editLikeMessage
} from '../../action/productAction.js';
import { Toast } from 'antd-mobile/lib';
import Util from "../../util.js";
import { setStorage } from '../../common.js';

export class ConsultationDetails extends PureComponent {
	state = { 
		isLogin: false,
		articleLike: false,
		message: "",
		likeCount: 0,
		pageNum: 1,
		pageSize: 50,
		isMoreMessage: false,
		allSource: []
	}

	componentDidMount () {
		let { dispatch } = this.props;
		const { pageNum, pageSize } = this.state;
		if(this.GetQueryString("articleId")) {
			dispatch(articleDetail(null));
			dispatch(articleMessageList([]));
			if(this.GetQueryString("token")) {
				let TM = new Date();
				setStorage('tokenTimeshort',TM.getTime()+window.tokenTimeshort);
				setStorage('loginInfo-shortToken', this.GetQueryString("token"));
				this.setState({
					isLogin: true
				});
			}else {
				this.setState({
					isLogin: false
				});
			}
			dispatch(getArticleDetail({articleId: this.GetQueryString("articleId"), token: this.GetQueryString("token")}, (data) => {
				this.setState({
					articleLike: data.hasLikeArticle,
					likeCount: data.likeCount ? data.likeCount : 0
				})
			}));
			dispatch(getArticleMessageList({articleId: this.GetQueryString("articleId"), token: this.GetQueryString("token"), pageNum: pageNum, pageSize: pageSize}, (data) => {
				if(data.commentCount > pageSize) {
					this.setState({
						isMoreMessage: true
					});
				}
				this.setState({
					allSource: [].concat(data.articleCommentResponses)
				});
			}));
		}
	}

	componentWillUnmount() {
		
	}

	GetQueryString = (name) => {
		var reg = new RegExp("(^|&)"+ name +"=([^&]*)(&|$)");
	    if(window.location.href.indexOf("?") != -1) {
	    	var _r = "?" + window.location.href.split("?")[window.location.href.split("?").length - 1];
		    var r = _r.substr(1).match(reg);
		    if(r!=null)return  unescape(r[2]); return "";
	    }else{
	    	return "";
	    }
	}

	ckArticle = () => {
		const { dispatch } = this.props;
		this.setState({
			articleLike: !this.state.articleLike,
			likeCount: !this.state.articleLike ? this.state.likeCount - 0 + 1 : this.state.likeCount - 1
		});
		dispatch(editLikeArticle({articleId: this.GetQueryString("articleId")}))
	}

	theTrim = (str) => {
		return str.replace(/(^\s*)|(\s*$)/g, "");
	}

	subArticleMessage = () => {
		const { dispatch } = this.props;
		const { message } = this.state;
		dispatch(writeArticleMessage({articleId: this.GetQueryString("articleId"), token: this.GetQueryString("token"), content: message}, (data) => {
			this.setState({
				message: ""
			});
			Toast.info("提交成功,请耐心等待审核", 2)
		}));
	}

	writeMessage = (event) => {
		this.setState({
			message: event.target.value
		})
	}

	showMore = () => {
		const { dispatch } = this.props;
		const { pageNum, pageSize, allSource } = this.state;
		Toast.loading();
		dispatch(getArticleMessageList({articleId: this.GetQueryString("articleId"), token: this.GetQueryString("token"), pageNum: pageNum - 0 + 1, pageSize: pageSize}, (data) => {
			if(data.articleCommentResponses.length > 0) {
				this.setState({
					allSource: allSource.concat(data.articleCommentResponses),
					pageNum: pageNum - 0 + 1,
					pageSize: pageSize,
					isMoreMessage: true 
				});
				Toast.hide();
			}else {
				Toast.hide();
				Toast.info("留言已全部加载", 2);
				this.setState({
					isMoreMessage: false
				});
			}
		}));
	}

	render() {
		const { articleDetail } = this.props;
		const { isLogin, articleLike, message, likeCount, isMoreMessage, allSource } = this.state;
		let title, source, createTime, content, pageView, tagName;
		if(articleDetail) {
			title = articleDetail.title ? articleDetail.title : "--";
			source = articleDetail.source ? articleDetail.source : "--";
			if(articleDetail.createTime) {
				if(((new Date().getTime() - new Date(articleDetail.createTime).getTime()) / 1000 / 3600).toFixed(0) > 24) {
					createTime = Util.returnDate(articleDetail.createTime);
				}else {
					if((new Date().getTime() - new Date(articleDetail.createTime).getTime()) / 1000 / 3600 < 1) {
						createTime = ((new Date().getTime() - new Date(articleDetail.createTime).getTime()) / 1000 / 3600 * 60).toFixed(0) + "分钟前";
					}else {
						createTime = ((new Date().getTime() - new Date(articleDetail.createTime).getTime()) / 1000 / 3600).toFixed(0) + "小时前";
					}
				}
			}else {
				createTime = "--";
			}
			content = articleDetail.content ? articleDetail.content : "";
			pageView = articleDetail.pageView ? articleDetail.pageView - 0 + 1 : 0;
			tagName = articleDetail.tagName ? articleDetail.tagName : "--";
			content = content.replace(/xmwebp/g,"xmorient")
		}
		return (
			<div style={{overflow: "hidden", width: document.documentElement.clientWidth, minHeight: document.documentElement.clientHeight}}>
				{
					articleDetail ? 
					<div>
						<div style={{WebkitFlex: 1, paddingBottom: isLogin ? 63 : 13}}>
							<div style={{background: "#fff", padding: 13,}}>
								<div style={{fontSize: 20, fontWeight: "bold", color: "#3a3e47"}}>{title}</div>
								<div style={{display: "-webkit-flex", WebkitJustifyContent: "space-between", WebkitFlexDirection: "row", fontSize: 12, paddingTop: 15, color: "#5b6370"}}>
									<div>{tagName} | {createTime}</div>
									<div>来源: {source}</div>
								</div>
								<div style={{paddingTop: 15}} dangerouslySetInnerHTML={{__html: content}}></div>
								<div style={{display: "-webkit-flex", WebkitJustifyContent: "space-between", WebkitFlexDirection: "row", fontSize: 12, paddingTop: 15, color: "#5b6370"}}>
									<div>浏览{pageView}</div>
									<div onClick={isLogin ? this.ckArticle : null}>{articleLike ? <img src={require("../../img/dzon.png")} style={{width: 13, height: 13, marginRight: 2}} /> : <img src={require("../../img/dzoff.png")} style={{width: 13, height: 13, marginRight: 2}} />}{likeCount}</div>
								</div>
							</div>
							{
								allSource.length > 0 ? 
								<div style={{background: "#fff", marginTop: 15, padding: 13}}>
									<div style={{paddingBottom: 10, color: "#3a3e47"}}>精选留言</div>
									{
										allSource.map((data, index) => {
											return (
												<ContainBox mobileNo={this.GetQueryString("mobileNo")} articleId={this.GetQueryString("articleId")} isLogin={isLogin} dataSource={data} key={index} />
											)
										})
									}
									{
										isMoreMessage ?
										<div onClick={this.showMore} style={{height: 30, display: "-webkit-flex", WebkitAlignItems: "center", WebkitJustifyContent: "center", marginTop: 10}}>加载更多</div>
										:
										null
									}
								</div>
								:
								null
							}
						</div>
						{
							isLogin ?
							<div style={{height: 50, background: "#f5f5f9", padding: 8, position: "fixed", bottom: 0, width: "100%", display: "-webkit-flex", WebkitFlexDirection: "row", WebkitAlignItems: "center"}}>
								<input style={{WebkitFlex: 1, height: "100%", paddingLeft: 15}} value={message} onChange={this.writeMessage} placeholder="留言将由平台筛选后显示" />
								{
									message && this.theTrim(message) ?
									<span onClick={this.subArticleMessage} style={{width: 60, display: "-webkit-flex", WebkitAlignItems: "center", WebkitJustifyContent: "center", background: "#fff", height: "100%"}}>提交</span>
									:
									<span onClick={() => {}} style={{width: 60, display: "-webkit-flex", WebkitAlignItems: "center", WebkitJustifyContent: "center", background: "#fff", height: "100%", color: "gray"}}>提交</span>
								}
							</div>
							:
							null
						}
					</div>
					:
					null
				}
			</div>
		);
	}
}

ConsultationDetails = connect(mapStateToProps)(ConsultationDetails)


export class ContainBox extends PureComponent {
	state = {
		messageLike: this.props.dataSource.hasLikeComment,
		likeCount: this.props.dataSource.likeCount ? this.props.dataSource.likeCount : 0
	}

	ckArticle = () => {
		const { dispatch, dataSource } = this.props;
		this.setState({
			messageLike: !this.state.messageLike,
			likeCount: !this.state.messageLike ? this.state.likeCount - 0 + 1 : this.state.likeCount - 1
		});
		dispatch(editLikeMessage({commentId: dataSource.commentId}))
	}

	render() {
		const { isLogin, dataSource, mobileNo } = this.props;
		const { messageLike, likeCount } = this.state;
		const content = dataSource.content ? dataSource.content : "";
		let newPhone = "";
		if(mobileNo) {
			for(let i = 0; i < mobileNo.length - 7; i++) {
				newPhone+="*";
			}
			newPhone = mobileNo.substr(0,3)+""+newPhone+""+mobileNo.substr(3+newPhone.length, mobileNo.length-3-newPhone.length);
		}else {
			newPhone = "注册用户";
		}
		const userName = dataSource.userName ? dataSource.userName : newPhone;
		return (
			<div style={{display: "-webkit-flex", WebkitFlexDirection: "row", WebkitAlignItems: "flex-start", marginTop: 10}}>
				<div style={{width: 40}}>
					<div style={{width: 25, height: 25, overflow: "hidden", borderRadius: 25}}>
						<img src={require("../../img/904hqtxq.png")} style={{width: "100%", height: "100%", }} />
					</div>
				</div>
				<div style={{borderBottom: "1px solid #f5f5f9", WebkitFlex: 1, paddingBottom: 10}}>
					<div style={{display: "-webkit-flex", WebkitJustifyContent: "space-between", WebkitFlexDirection: "row", fontSize: 13}}>
						<div style={{fontSize: 13, color: "#3a3e47", fontWeight: "bold"}}>{userName}</div>
						<div onClick={isLogin ? this.ckArticle : null}>{messageLike ? <img src={require("../../img/dzon.png")} style={{width: 13, height: 13, marginRight: 2}} /> : <img src={require("../../img/dzoff.png")} style={{width: 13, height: 13, marginRight: 2}} />}{likeCount}</div>
					</div>
					<div style={{paddingTop: 5, wordBreak: "break-all", color: "#5b6370", fontSize: 15}}>{content}</div>
				</div>
			</div>
		)
	}
}

ContainBox = connect(mapStateToProps)(ContainBox)

function mapStateToProps(state,ownProps) {
  return {
    articleDetail: state.articleDetail
  }
}


// WEBPACK FOOTER //
// ./src/components/product/ConsultationDetails.js